import { apiClient } from './apiClient';

export type FactoryStaffCapability = {
  id: string;
  userId: string;
  accountId: string;
  phone: string;
  username: string | null;
  status: 'pending' | 'approved' | 'suspended' | 'revoked' | string;
  role: 'worker' | 'manager' | string;
  appliedAt: string;
  reviewedAt: string | null;
  reviewedBy: string | null;
  note: string;
};

export type FactoryWorkerDirectoryEntry = {
  userId: string;
  accountId: string;
  displayName: string;
  role: 'worker' | 'manager' | string;
};

export const factoryStaffService = {
  async listCapabilities(status?: string): Promise<FactoryStaffCapability[]> {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    const res = await apiClient.requestJson<{
      success?: boolean;
      capabilities?: FactoryStaffCapability[];
      error?: string;
    }>(`/api/factory-worker/capabilities${qs}`, { auth: true });
    return res.capabilities || [];
  },

  /** Approved workers for Owner order assignment (any diary account). */
  async listApprovedWorkers(): Promise<FactoryWorkerDirectoryEntry[]> {
    const res = await apiClient.requestJson<{
      success?: boolean;
      workers?: FactoryWorkerDirectoryEntry[];
      error?: string;
      message?: string;
    }>('/api/factory-worker/directory', { auth: true });
    return res.workers || [];
  },

  async review(
    userId: string,
    body: {
      status: 'approved' | 'suspended' | 'revoked';
      role?: 'worker' | 'manager';
      note?: string;
    },
  ): Promise<FactoryStaffCapability> {
    const res = await apiClient.requestJson<{
      success?: boolean;
      capability?: FactoryStaffCapability;
      error?: string;
      message?: string;
    }>(`/api/factory-worker/capabilities/${encodeURIComponent(userId)}/review`, {
      method: 'POST',
      body,
      auth: true,
    });
    if (!res.capability) {
      throw new Error(res.message || res.error || '审批失败');
    }
    return res.capability;
  },

  async apply(note?: string): Promise<FactoryStaffCapability> {
    const res = await apiClient.requestJson<{
      success?: boolean;
      capability?: FactoryStaffCapability;
      error?: string;
    }>('/api/factory-worker/apply', {
      method: 'POST',
      body: { note },
      auth: true,
    });
    if (!res.capability) throw new Error(res.error || '申请失败');
    return res.capability;
  },
};
